import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./styles/home.css";
import "./styles/mediaqueries.css";
import btnBg from "../Assets/images/Btn_Common01_Hover.png";
import inputBg from "../Assets/images/About_Email_Inputbox.png";
import Footer from "../components/Footer";
import xIcon from "../Assets/images/Icon_X.png";
import fbIcon from "../Assets/images/Icon_Facebook.png";
import igIcon from "../Assets/images/Icon_Instagram.png";
import discordIcon from "../Assets/images/Icon_Discord.png";
import twitchIcon from "../Assets/images/Icon_Twitch.png";
import featureBg from "../Assets/images/About_Trait_Frame.png";
import steamIcon from "../Assets/images/Icon_Steam.png";
import about1 from "../Assets/images/about1.jpg";
import about2 from "../Assets/images/about2.jpg";
import about3 from "../Assets/images/about3.jpg";
import about4 from "../Assets/images/about4.jpg";
import about5 from "../Assets/images/about5.jpg";
import OptimizedDiv from "../components/OptimizedDiv";
import heroBg1High from "../Assets/images/hero-bg-1-high.jpg";
import heroBg1Low from "../Assets/images/hero-bg-1-low.jpg";
import featuresBgHigh from "../Assets/images/about-bg.jpg";
import featuresBgLow from "../Assets/images/about-bg-low.jpg";
import section2BgHigh from "../Assets/images/Background02.jpg";
import section2Bglow from "../Assets/images/Background02-low.jpg";
import itemsFrame from "../Assets/images/Items_Frame.png";

const Home = () => {
  const inputRef = useRef("");
  const [newsletterPopup, setNewsletterPopup] = useState({
    open: false,
    msg: "",
  });

  async function submitForm() {
    let email = inputRef.current.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setNewsletterPopup({
        open: true,
        msg: "Please enter a valid email address.",
      });
      setTimeout(() => {
        setNewsletterPopup({
          open: false,
          msg: "",
        });
      }, 3000);
      return;
    }
    const payload = {
      email: email,
      someFlags: 0,
    };
    try {
      const res = await axios.post(
        "https://cotp-game.azurewebsites.net/api/GamePromo/SubscribeToGameNews",
        payload
      );
      const data = await res;
      if (data.status === 200) {
        inputRef.current.value = "";
        setNewsletterPopup({
          open: true,
          msg: "Thanks for Subscribing!",
        });
        setTimeout(() => {
          setNewsletterPopup({
            open: false,
            msg: "",
          });
        }, 3000);
        return;
      }
    } catch (err) {
      console.log(err);
      setNewsletterPopup({
        open: true,
        msg: "Something went wrong!",
      });
      setTimeout(() => {
        setNewsletterPopup({
          open: false,
          msg: "",
        });
      }, 3000);
    }
  }
  useEffect(() => {
    document.title = "Roshpit Champions II | Home";
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <OptimizedDiv
        className={"hero_section"}
        highResImageSrc={heroBg1High}
        lowResImageSrc={heroBg1Low}
      >
        {newsletterPopup.open ? (
          <div className="popup_overlay">
            <div className="popup">
              <img className="items_frame" src={itemsFrame} alt="" srcset="" />
              <p>{newsletterPopup.msg}</p>
            </div>
          </div>
        ) : null}
        <div className="hero_content p-3">
          <p className="hero_content_heading heading text-center">
            'Calling Back
            <br />
            All Champions'
          </p>
          <p className="hero_content_desc">
            Roshpit Champions is back with a brand new take on the Action RPG
            genre! Veterans and newcomers are invited to participate in a
            remastered world full of danger, challenge and conquest.
          </p>
          <div className="hero_content_newsletter">
            <p className="message"></p>
            <div className="hero_content_btn">
              <button
                className="hero_content_btn_btn"
                type="submit"
                onClick={submitForm}
              >
                <img src={btnBg} alt="" srcset="" />
                <span>Subscribe</span>
              </button>
            </div>
            <div className="newsletter-input-wrapper">
              <img src={inputBg} alt="" srcset="" />
              <input
                type="text"
                id="newsletter-input"
                placeholder="YOUR EMAIL"
                ref={inputRef}
              />
            </div>
          </div>
        </div>
        <div className="social_icons">
          <p className="d-block">
            Join our community for latest updates and news.
          </p>
          <div className="social_icons_icons">
            <a href="https://x.com/roshpit" target="_">
              <img src={xIcon} alt="" srcset="" />
            </a>
            <a href="https://www.facebook.com/roshpitchampions" target="_">
              <img src={fbIcon} alt="" srcset="" />
            </a>
            <a href="https://www.instagram.com/roshpitchampions" target="_">
              <img src={igIcon} alt="" srcset="" />
            </a>
            <a href="https://discord.gg/ZPbpdjxTsF" target="_">
              <img src={discordIcon} alt="" srcset="" />
            </a>
            <a href="https://www.twitch.tv/chalkybrush" target="_">
              <img src={twitchIcon} alt="" srcset="" />
            </a>
            <a
              href="https://store.steampowered.com/app/2783670/Roshpit_Champions_2/"
              target="_"
            >
              <img src={steamIcon} alt="" srcset="" />
            </a>
          </div>
        </div>
      </OptimizedDiv>
      <OptimizedDiv
        className={"section_two"}
        highResImageSrc={section2BgHigh}
        lowResImageSrc={section2Bglow}
        gradient={false}
      >
        <div className="container">
          <div className="section_two_content p-3">
            <h1 className="section_two_content_heading heading">
              Back with a vengeance!
            </h1>
            <p className="section_two_content_desc desc">
              Breaking free from Action RPG conventions, Roshpit Champions 2
              aims to deliver a brand new online gaming experience. Enjoy a
              totally reimagined 3D world with updated classes, equipment, maps
              and bosses.
            </p>
            <div className="section_two_content_video">
              <video autoPlay muted loop id="myVideo">
                <source
                  src={
                    "https://rpc2-game.s3.us-west-1.amazonaws.com/RpcData/site_video_files/Fast+Pace.mp4"
                  }
                  type="video/mp4"
                />
              </video>
            </div>
            <div className="section_two_content_features gap-5">
              <div className="section_two_content_features_block flex-column gap-3">
                <p>30 Diverse Classes</p>
                <span>
                  From an archer of the stars to a relentless demon terrorizing
                  the skies, Roshpit Champions 2 offers a range of classes that
                  cater to every play style. Whether you like to stand at the
                  forefront of battles, strategize from afar, or support your
                  allies with heals and buffs, there's a class tailored just for
                  you.
                </span>
                <img src={featureBg} alt="" srcset="" />
              </div>

              <div className="section_two_content_features_block flex-column gap-3">
                <p>3D Environments</p>
                <span>
                  A new control scheme and 3D world empowers you with new ways
                  to explore. Step into a carefully designed tapestry of worlds,
                  from mystical forests to fiery volcanoes. Delve deep into
                  hidden caves, swim across lakes and ponds, and confront hidden
                  bosses.
                </span>
                <img src={featureBg} alt="" srcset="" />
              </div>

              <div className="section_two_content_features_block flex-column gap-3">
                <p>Online Multiplayer</p>
                <span>
                  Join other players in an online co-op adventure, and engage
                  with a dynamic economy. The game also offers a fully offline
                  single-player experience!
                </span>
                <img src={featureBg} alt="" srcset="" />
              </div>
            </div>
          </div>
        </div>
      </OptimizedDiv>

      <div className="section_three">
        <OptimizedDiv
          className={"game_features"}
          highResImageSrc={featuresBgHigh}
          lowResImageSrc={featuresBgLow}
          gradient={false}
        >
          <div className="container">
            <div className="game_features_container flex-column flex-md-row gap-md-5">
              <div className="about-image">
                <img src={about1} alt="" srcset="" />
              </div>
              <div className="game_features_info">
                <p className="game_features_info_heading ">
                  Expansive World with the Freedom to Explore
                </p>

                <span>
                  Roshpit Champions 2 has completely remade the 2d world into a
                  fully fleshed-out 3D universe without invisible barriers!
                  Players are encouraged to wander, climb, and discover to their
                  heart's content. Worlds are designed with full mobility in
                  mind, giving you the option to skip past a troublesome boss or
                  rush through to the next zone.
                </span>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="game_features_container flex-column flex-md-row gap-md-5">
              <div className="game_features_info">
                <p className="game_features_info_heading ">
                  Familiar Heroes with New Faces
                </p>

                <span>
                  The original classes of Roshpit Champions have been ported
                  over to the newest iteration, with some fresh new looks and
                  upgraded skillsets! Enjoy playing the classic heroes such as
                  Flamewaker, Astral Ranger, and Seinaru with upgraded skills,
                  talents, and a new zodiac passive tree to buff up and
                  customize your combat capability.
                </span>
              </div>
              <div className="about-image">
                <img src={about2} alt="" srcset="" />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="game_features_container flex-column flex-md-row gap-md-5">
              <div className="about-image">
                <img src={about3} alt="" srcset="" />
              </div>
              <div className="game_features_info">
                <p className="game_features_info_heading ">
                  Updated Combat System
                </p>

                <span>
                  The combat system has been redesigned from the ground up,
                  offering a swathe of customization options and a massive power
                  curve as you rise from a level 1 with basic attacks to an
                  ascended champion that clears waves of mobs in seconds.
                  Customize your equipment, talents, and zodiac passives to
                  create a build that is uniquely yours, and enjoy taking on
                  challenges using your preferred playstyle.
                </span>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="game_features_container flex-column flex-md-row gap-md-5">
              <div className="game_features_info">
                <p className="game_features_info_heading ">
                  Remastered Equipment and Loot
                </p>

                <span>
                  Power up and redefine what's possible with each piece of
                  equipment that you claim. With 100s of standard items and 300
                  uniques, the new loot system empowers you to elevate your hero
                  in multiple dimensions. Whether you're embracing a
                  straightforward stat boost or reveling in newfound mobility,
                  each affix is specially designed to provide substantial and
                  intriguing enhancements.
                </span>
              </div>
              <div className="about-image">
                <img src={about4} alt="" srcset="" />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="game_features_container flex-column flex-md-row gap-md-5">
              <div className="about-image">
                <img src={about5} alt="" srcset="" />
              </div>
              <div className="game_features_info">
                <p className="game_features_info_heading ">
                  Multiplayer Action
                </p>

                <span>
                  Join other players in an online co-op adventure, and engage
                  with a dynamic economy. The game fully supports cooperative
                  play with other heroes, and allows for dueling and trading.
                  You can show off your build to your friends or strangers, and
                  work with them to take down difficult challenges. The game
                  also supports a fully offline single-player mode for those
                  with a weak internet connection or just playing on the go!
                </span>
              </div>
            </div>
          </div>
        </OptimizedDiv>
      </div>
      <Footer />
    </>
  );
};

export default Home;
